import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { CdkListbox, CdkOption } from '@angular/cdk/listbox';
import { IconComponent } from '../../../shared/icon/icon.component';
import { FilterDropdown } from '../../../shared/directives/filter-dropdown';
import { CUSTOMER_SORTS, type CustomerSort } from '../customer-sort';

/** Dropdown choosing the customer list order, styled like the statistics filters. */
@Component({
  selector: 'app-customer-sort-select',
  imports: [CdkListbox, CdkOption, IconComponent],
  templateUrl: './customer-sort-select.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'relative' },
  hostDirectives: [FilterDropdown],
})
export class CustomerSortSelect {
  protected readonly dropdown = inject(FilterDropdown);

  readonly value = model<CustomerSort>('lastOrderAt');

  protected readonly options = CUSTOMER_SORTS;
  protected readonly selected = computed(
    () => CUSTOMER_SORTS.find((option) => option.value === this.value()) ?? CUSTOMER_SORTS[0],
  );
}
